import React, { useState } from 'react';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Plans from './pages/Plans';
import Payment from './pages/Payment';
import AdminDashboard from './pages/AdminDashboard';
import ForgotPassword from './pages/ForgotPassword';

function App() {
  const [currentPage, setCurrentPage] = useState('login');
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleLogin = (userData, userToken) => {
    setUser(userData);
    setToken(userToken);
    setCurrentPage('dashboard');
  };

  const handleLogout = () => {
    setUser(null);
    setToken(null);
    setCurrentPage('login');
  };

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    setCurrentPage('payment');
  };

  return (
    <div className="min-h-screen bg-teal-50">
      {currentPage === 'login' && (
        <Login
          onLogin={handleLogin}
          onGoRegister={() => setCurrentPage('register')}
          onAdmin={() => setCurrentPage('admin')}
          onForgotPassword={() => setCurrentPage('forgot-password')}
        />
      )}
      {currentPage === 'register' && (
        <Register
          onGoLogin={() => setCurrentPage('login')}
        />
      )}
      {currentPage === 'forgot-password' && (
        <ForgotPassword
          onGoLogin={() => setCurrentPage('login')}
        />
      )}
      {currentPage === 'dashboard' && (
        <Dashboard
          user={user}
          token={token}
          onLogout={handleLogout}
          onUpgrade={() => setCurrentPage('plans')}
        />
      )}
      {currentPage === 'plans' && (
        <Plans
          user={user}
          onSelectPlan={handleSelectPlan}
          onBack={() => setCurrentPage('dashboard')}
        />
      )}
      {currentPage === 'payment' && (
        <Payment
          user={user}
          plan={selectedPlan}
          onBack={() => setCurrentPage('plans')}
          onSuccess={() => setCurrentPage('dashboard')}
        />
      )}
      {currentPage === 'admin' && (
        <AdminDashboard
          onBack={() => setCurrentPage('login')}
        />
      )}
    </div>
  );
}

export default App;
